export const WOOCOMMERCE_TUCKERTUB_LOCALSTORAGE_CART_ID = 'woocommerce-tuckertub_cart_id'
export const WOOCOMMERCE_TUCKERTUB_LOCALSTORAGE_CART = 'woocommerce-tuckertub_cart'
export const WOOCOMMERCE_TUCKERTUB_LOCALSTORAGE_ORDER = 'woocommerce-tuckertub_order'
export const WOOCOMMERCE_TUCKERTUB_LOCALSTORAGE_ORDER_EMAIL = 'woocommerce-tuckertub_order_email'
export const WOOCOMMERCE_TUCKERTUB_ORDER = 'woocommerce-tuckertub_woo_order'
export const WOOCOMMERCE_TUCKERTUB_LOCALSTORAGE_CUSTOMER_INFO =
  'woocommerce-tuckertub_customer_info'
export const STRIPE_TUCKERTUB_PAYMENT_INTENT_CLIENT_SECRET =
  'stripe-tuckertub-payment-intent-client-secret'
export const STRIPE_TUCKERTUB_PAYMENT_INTENT_ID = 'stripe-tuckertub-payment-intent-id'
export const TUCKERTUB_AUTH_SESSION_ID = 'tuckertub-auth-session-id'
export const STRIPE_TUCKERTUB_AFTERPAY_PAYMENT_INTENT_CLIENT_SECRET =
  'stripe-tuckertub-afterpay-payment-intent-client-secret'
export const STRIPE_TUCKERTUB_AFTERPAY_PAYMENT_INTENT_ID =
  'stripe-tuckertub-afterpay-payment-intent-id'
export const STRIPE_TUCKERTUB_APPLEPAY_PAYMENT_INTENT_CLIENT_SECRET =
  'stripe-tuckertub-applepay-payment-intent-client-secret'
export const STRIPE_TUCKERTUB_APPLEPAY_PAYMENT_INTENT_ID =
  'stripe-tuckertub-applepay-payment-intent-id'
